import { css } from '@emotion/css'
import { colors } from 'settings/colors'

export const pickerControlClassName = css({
  'border': `2px solid ${colors.grey800}`,
  'backgroundColor': colors.white,
  'borderRadius': '16px',
  'margin': 2,
  'height': 32,
  'maxWidth': 80,
  '&[data-disabled]': {
    'border': '2px solid transparent',
    'color': colors.grey500,
    '&:hover': { backgroundColor: colors.white },
  },
})
